import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgStyle} from '@angular/common';


export type ProgressColor = 'blue' | 'green' | 'yellow' | 'red';


@Component({
  selector: 'moti-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgStyle,
  ],
})
export class ProgressBarComponent {
  @Input() numerator: number = 0;
  @Input() denominator: number = 0;
  @Input() zeroProgressText: string = 'Getting Started';
  @Input() showPercentage: boolean = true;
  @Input() animated: boolean = true;
  @Input() color: ProgressColor = 'blue';
}
